import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MegaMenuItem } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { InputTextModule } from 'primeng/inputtext';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { MegaMenu } from 'primeng/megamenu';
import { DrawerModule } from 'primeng/drawer';
import { Ripple } from 'primeng/ripple';
import { DomSanitizer } from '@angular/platform-browser';
import { StorageService } from '../../../auth/storage.service';
import { LocationService } from '../../../auth/guard/auth/guard/location.service';
import { MyMenuItem } from './mymenuItwm';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import {
  selectCartProducts,
  selectNumOfCartItems,
} from '../../../../store/cart/cart.selectors';
import { Store } from '@ngrx/store';
import { selectDarkMode } from '../../../../store/theme/theme.selectors';
import { toggleTheme } from '../../../../store/theme/theme.actions';
import { Observable } from 'rxjs';
import { selectWishlistId } from 'apps/RoseApp/src/store/wishlist/wishlist.selectors';
import { AuthService } from '@elevate-workspace/auth';
import { AddressComponent } from '../../../pages/address/address.component';
import { Address } from '../../../shared/interface/address';
import { loadCart } from '../../../../store/cart/cart.actions';
import { loadWishlist } from '../../../../store/wishlist/wishlist.action';

@Component({
  selector: 'app-navbar',
  imports: [
    MenubarModule,
    BadgeModule,
    TranslatePipe,
    AvatarModule,
    InputTextModule,
    RouterModule,
    Ripple,
    CommonModule,
    MegaMenu,
    DrawerModule,
    ButtonModule,
    RouterLink,
    DialogModule,
    AddressComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  ngOnInit() {
    this.wishlistIds$ = this.store.select(selectWishlistId);
    this.cartCount$ = this.store.select(selectNumOfCartItems);
    this.loadFirstName();
    if (this.isLoggedIn) {
      this.store.dispatch(loadWishlist());
      this.store.dispatch(loadCart());
    }
    const savedCity = localStorage.getItem('selectedCity');
    if (savedCity) {
      this.selectedCity = savedCity;
    }

    this.loadUserLocation();

    window.addEventListener('user-updated', this.onUserUpdated);
    const savedLang = localStorage.getItem('lang');
    if (savedLang) {
      this.defaultLang = savedLang;
      this.lang = savedLang === 'ar' ? 'العربية' : 'English';
      this.translate.use(this.defaultLang);
      document.documentElement.dir = this.defaultLang === 'ar' ? 'rtl' : 'ltr';
      this.buildMenus();
    }
  }
  items: MyMenuItem[] | undefined;
  logins: MegaMenuItem[] | undefined;
  firstName: string | null = null;
  photo: string | null = null;
  city: string | null = null;
  visible = false;
  visiblee = false;
  selectedCity: string | null = null;
  lang = 'العربية';
  defaultLang = 'en';

  translate = inject(TranslateService);
  private _service = inject(AuthService);
  _router = inject(Router);
  private store = inject(Store);
  darkMode$ = this.store.select(selectDarkMode);
  _StorageService = inject(StorageService);
  _sanitizer = inject(DomSanitizer);
  _locationService = inject(LocationService);
  message = inject(MessageService);

  wishlistIds$!: Observable<string[]>;
  wishlistConfirmVisible: boolean = false;
  cartCount$ = this.store.select(selectNumOfCartItems);
  get isLoggedIn(): boolean {
    return !!this._StorageService.getItem('token');
  }

  onNotLoggedIn(): void {
    this.message.add({
      severity: 'warn',
      summary: 'Login required',
      detail: 'Please login to view your wishlist',
      life: 2000,
    });
  }
  onAddressChange(address: Address) {
    this.selectedCity = address.city!;
    this.visiblee = false;
  }
  resetCity() {
    this.selectedCity = null;
    localStorage.removeItem('selectedCity');
  }
  cartonNotLoggedIn(): void {
    this.message.add({
      summary: 'Login required',
      detail: 'Please login to view your cart',
      life: 2000,
    });
  }
  goToCart(): void {
    this._router.navigate(['/cart']);
  }

  goToWishlist(): void {
    this._router.navigate(['/wishlist']);
  }
  switchLanguage() {
    this.defaultLang = this.defaultLang === 'en' ? 'ar' : 'en';
    localStorage.setItem('lang', this.defaultLang);
    this.lang = this.lang === 'العربية' ? 'English' : 'العربية';
    document.documentElement.dir = this.defaultLang === 'ar' ? 'rtl' : 'ltr';
    this.translate.use(this.defaultLang).subscribe(() => {
      this.buildMenus();
    });
  }
  //location

  buildMenus() {
    this.logins = [
      {
        label: this.firstName
          ? this.firstName
          : this.translate.instant('LOGIN'),
        items: [
          [
            {
              label: this.firstName
                ? this.firstName
                : this.translate.instant('LOGIN'),
              items: [
                {
                  label: this.translate.instant('MY_PROFILE'),
                  template: () =>
                    this._sanitizer
                      .bypassSecurityTrustHtml(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6668 14V12.6667C12.6668 11.9594 12.3859 11.2811 11.8858 10.781C11.3857 10.281 10.7074 10 10.0002 10H6.00016C5.29292 10 4.61464 10.281 4.11454 10.781C3.61445 11.2811 3.3335 11.9594 3.3335 12.6667V14" stroke="#3F3F46" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.00016 7.33333C9.47292 7.33333 10.6668 6.13943 10.6668 4.66667C10.6668 3.19391 9.47292 2 8.00016 2C6.5274 2 5.3335 3.19391 5.3335 4.66667C5.3335 6.13943 6.5274 7.33333 8.00016 7.33333Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`),
                  routerLink: '/profile',
                  icon: 'pi pi-user',
                },
                {
                  label: this.translate.instant('MY_ADDRESSES'),
                  template: () =>
                    this._sanitizer
                      .bypassSecurityTrustHtml(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_16745_15507)">
<path d="M12.0002 6.66634C12.0002 5.25185 11.4383 3.8953 10.4381 2.8951C9.43787 1.89491 8.08132 1.33301 6.66683 1.33301C5.25234 1.33301 3.89579 1.89491 2.89559 2.8951C1.8954 3.8953 1.3335 5.25185 1.3335 6.66634C1.3335 9.99501 5.02616 13.4617 6.26616 14.5323C6.38174 14.619 6.52235 14.6658 6.66683 14.6657M12.0002 14.6663V12.6663M10.0002 14.6663C9.82335 14.6663 9.65378 14.5961 9.52876 14.4711C9.40373 14.3461 9.3335 14.1765 9.3335 13.9997V11.333C9.33348 11.2233 9.36055 11.1152 9.4123 11.0185C9.46405 10.9217 9.53889 10.8392 9.63016 10.7783L11.6302 9.44501C11.7397 9.37192 11.8685 9.33291 12.0002 9.33291C12.1319 9.33291 12.2606 9.37192 12.3702 9.44501L14.3702 10.7783C14.4614 10.8392 14.5363 10.9217 14.588 11.0185C14.6398 11.1152 14.6668 11.2233 14.6668 11.333V13.9997C14.6668 14.1765 14.5966 14.3461 14.4716 14.4711C14.3465 14.5961 14.177 14.6663 14.0002 14.6663H10.0002ZM8.66683 6.66634C8.66683 7.77091 7.7714 8.66634 6.66683 8.66634C5.56226 8.66634 4.66683 7.77091 4.66683 6.66634C4.66683 5.56177 5.56226 4.66634 6.66683 4.66634C7.7714 4.66634 8.66683 5.56177 8.66683 6.66634Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_16745_15507">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
`),
                  icon: 'pi pi-map-marker',
                  command: (event) => {
                    event?.originalEvent?.preventDefault();
                    event?.originalEvent?.stopPropagation();

                    setTimeout(() => {
                      this.showDialog();
                    }, 0);
                  },
                },
                {
                  label: this.translate.instant('MY_ORDERS'),
                  template: () =>
                    this._sanitizer
                      .bypassSecurityTrustHtml(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0002 8H6.66683M10.0002 5.33333H6.66683M12.6668 11.3333V3.33333C12.6668 2.97971 12.5264 2.64057 12.2763 2.39052C12.0263 2.14048 11.6871 2 11.3335 2H2.66683M2.66683 2C3.02045 2 3.35959 2.14048 3.60964 2.39052C3.85969 2.64057 4.00016 2.97971 4.00016 3.33333V12.6667C4.00016 13.0203 4.14064 13.3594 4.39069 13.6095C4.64074 13.8595 4.97987 14 5.3335 14M2.66683 2C2.31321 2 1.97407 2.14048 1.72402 2.39052C1.47397 2.64057 1.3335 2.97971 1.3335 3.33333V4.66667C1.3335 4.84348 1.40373 5.01305 1.52876 5.13807C1.65378 5.2631 1.82335 5.33333 2.00016 5.33333H4.00016M5.3335 14H13.3335C13.6871 14 14.0263 13.8595 14.2763 13.6095C14.5264 13.3594 14.6668 13.0203 14.6668 12.6667V12C14.6668 11.8232 14.5966 11.6536 14.4716 11.5286C14.3465 11.4036 14.177 11.3333 14.0002 11.3333H7.3335C7.15669 11.3333 6.98712 11.4036 6.86209 11.5286C6.73707 11.6536 6.66683 11.8232 6.66683 12V12.6667C6.66683 13.0203 6.52635 13.3594 6.2763 13.6095C6.02626 13.8595 5.68712 14 5.3335 14Z" stroke="#3F3F46" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`),
                  icon: 'pi pi-shopping-cart',
                  routerLink: '/allOrders',
                },
                {
                  label: this.translate.instant('DASHBOARD'),
                  template: () =>
                    this._sanitizer
                      .bypassSecurityTrustHtml(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.14667 1.33301H7.85333C7.49971 1.33301 7.16057 1.47348 6.91053 1.72353C6.66048 1.97358 6.52 2.31272 6.52 2.66634V2.78634C6.51976 3.02016 6.45804 3.2498 6.34103 3.45223C6.22401 3.65466 6.05583 3.82277 5.85333 3.93967L5.56667 4.10634C5.36398 4.22337 5.13405 4.28497 4.9 4.28497C4.66595 4.28497 4.43603 4.22337 4.23333 4.10634L4.13333 4.05301C3.82738 3.87652 3.46389 3.82864 3.12267 3.91988C2.78145 4.01112 2.49037 4.23403 2.31333 4.53967L2.16667 4.79301C1.99018 5.09896 1.9423 5.46245 2.03354 5.80367C2.12478 6.1449 2.34769 6.43597 2.65333 6.61301L2.75333 6.67967C2.95485 6.79601 3.12241 6.96307 3.23937 7.16423C3.35632 7.36539 3.4186 7.59366 3.42 7.82634V8.16634C3.42093 8.40129 3.35977 8.63231 3.2427 8.83601C3.12563 9.03972 2.95681 9.20887 2.75333 9.32634L2.65333 9.38634C2.34769 9.56338 2.12478 9.85445 2.03354 10.1957C1.9423 10.5369 1.99018 10.9004 2.16667 11.2063L2.31333 11.4597C2.49037 11.7653 2.78145 11.9882 3.12267 12.0795C3.46389 12.1707 3.82738 12.1228 4.13333 11.9463L4.23333 11.893C4.43603 11.776 4.66595 11.7144 4.9 11.7144C5.13405 11.7144 5.36398 11.776 5.56667 11.893L5.85333 12.0597C6.05583 12.1766 6.22401 12.3447 6.34103 12.5471C6.45804 12.7495 6.51976 12.9792 6.52 13.213V13.333C6.52 13.6866 6.66048 14.0258 6.91053 14.2758C7.16057 14.5259 7.49971 14.6663 7.85333 14.6663H8.14667C8.50029 14.6663 8.83943 14.5259 9.08948 14.2758C9.33952 14.0258 9.48 13.6866 9.48 13.333V13.213C9.48024 12.9792 9.54196 12.7495 9.65897 12.5471C9.77599 12.3447 9.94418 12.1766 10.1467 12.0597L10.4333 11.893C10.636 11.776 10.866 11.7144 11.1 11.7144C11.334 11.7144 11.564 11.776 11.7667 11.893L11.8667 11.9463C12.1726 12.1228 12.5361 12.1707 12.8773 12.0795C13.2186 11.9882 13.5096 11.7653 13.6867 11.4597L13.8333 11.1997C14.0098 10.8937 14.0577 10.5302 13.9665 10.189C13.8752 9.84779 13.6523 9.55671 13.3467 9.37967L13.2467 9.32634C13.0432 9.20887 12.8744 9.03972 12.7573 8.83601C12.6402 8.63231 12.5791 8.40129 12.58 8.16634V7.83301C12.5791 7.59806 12.6402 7.36704 12.7573 7.16334C12.8744 6.95963 13.0432 6.79048 13.2467 6.67301L13.3467 6.61301C13.6523 6.43597 13.8752 6.1449 13.9665 5.80367C14.0577 5.46245 14.0098 5.09896 13.8333 4.79301L13.6867 4.53967C13.5096 4.23403 13.2186 4.01112 12.8773 3.91988C12.5361 3.82864 12.1726 3.87652 11.8667 4.05301L11.7667 4.10634C11.564 4.22337 11.334 4.28497 11.1 4.28497C10.866 4.28497 10.636 4.22337 10.4333 4.10634L10.1467 3.93967C9.94418 3.82277 9.77599 3.65466 9.65897 3.45223C9.54196 3.2498 9.48024 3.02016 9.48 2.78634V2.66634C9.48 2.31272 9.33952 1.97358 9.08948 1.72353C8.83943 1.47348 8.50029 1.33301 8.14667 1.33301Z" stroke="#3F3F46" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 9.99967C9.10457 9.99967 10 9.10424 10 7.99967C10 6.8951 9.10457 5.99967 8 5.99967C6.89543 5.99967 6 6.8951 6 7.99967C6 9.10424 6.89543 9.99967 8 9.99967Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`),
                  icon: 'pi pi-home',
                },
                {
                  label: this.translate.instant('LOGOUT'),
                  template: () =>
                    this._sanitizer
                      .bypassSecurityTrustHtml(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6" stroke="#3F3F46" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6665 11.3337L13.9998 8.00033L10.6665 4.66699" stroke="#3F3F46" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 8H6" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`),
                  icon: 'pi pi-sign-out',
                  command: () => {
                    this._service.logout().subscribe({
                      next: () => {
                        this._router.navigate(['/home']).then(() => {
                          window.location.reload();
                        });
                        localStorage.clear();
                      },
                    });
                  },
                },
              ],
            },
          ],
        ],
      },
    ];

    this.items = [
      {
        label: 'HOME',
        routerLink: '/home',
        command: () => {
          this.visible = false;
          this._router.navigate(['/home']);
        },
        template: () =>
          this._sanitizer.bypassSecurityTrustHtml(`
<svg width="20" class="menu-icon" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 17.4999V10.8332C12.5 10.6122 12.4122 10.4002 12.2559 10.244C12.0996 10.0877 11.8877 9.99989 11.6667 9.99989H8.33333C8.11232 9.99989 7.90036 10.0877 7.74408 10.244C7.5878 10.4002 7.5 10.6122 7.5 10.8332V17.4999M2.5 8.33322C2.49994 8.09078 2.55278 7.85124 2.65482 7.63132C2.75687 7.4114 2.90566 7.21639 3.09083 7.05989L8.92417 2.06073C9.22499 1.80648 9.60613 1.66699 10 1.66699C10.3939 1.66699 10.775 1.80648 11.0758 2.06073L16.9092 7.05989C17.0943 7.21639 17.2431 7.4114 17.3452 7.63132C17.4472 7.85124 17.5001 8.09078 17.5 8.33322V15.8332C17.5 16.2753 17.3244 16.6992 17.0118 17.0117C16.6993 17.3243 16.2754 17.4999 15.8333 17.4999H4.16667C3.72464 17.4999 3.30072 17.3243 2.98816 17.0117C2.67559 16.6992 2.5 16.2753 2.5 15.8332V8.33322Z" stroke="currentColor" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`),
      },
      {
        label: 'Products',
        routerLink: '/products',
        template: () =>
          this._sanitizer.bypassSecurityTrustHtml(`
        <svg width="20" class="menu-icon" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 6.66703V17.5004M10 6.66703C9.69856 5.42487 9.17954 4.36292 8.51061 3.61966C7.84169 2.87641 7.0539 2.48636 6.25 2.50036C5.69747 2.50036 5.16756 2.71986 4.77686 3.11056C4.38616 3.50126 4.16667 4.03116 4.16667 4.5837C4.16667 5.13623 4.38616 5.66614 4.77686 6.05684C5.16756 6.44754 5.69747 6.66703 6.25 6.66703M10 6.66703C10.3014 5.42487 10.8205 4.36292 11.4894 3.61966C12.1583 2.87641 12.9461 2.48636 13.75 2.50036C14.3025 2.50036 14.8324 2.71986 15.2231 3.11056C15.6138 3.50126 15.8333 4.03116 15.8333 4.5837C15.8333 5.13623 15.6138 5.66614 15.2231 6.05684C14.8324 6.44754 14.3025 6.66703 13.75 6.66703M15.8333 10.0004V15.8337C15.8333 16.2757 15.6577 16.6996 15.3452 17.0122C15.0326 17.3248 14.6087 17.5004 14.1667 17.5004H5.83333C5.39131 17.5004 4.96738 17.3248 4.65482 17.0122C4.34226 16.6996 4.16667 16.2757 4.16667 15.8337V10.0004M3.33333 6.66703H16.6667C17.1269 6.66703 17.5 7.04013 17.5 7.50036V9.16703C17.5 9.62727 17.1269 10.0004 16.6667 10.0004H3.33333C2.8731 10.0004 2.5 9.62727 2.5 9.16703V7.50036C2.5 7.04013 2.8731 6.66703 3.33333 6.66703Z" stroke="currentColor" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
</svg> `),
      },
      {
        label: 'CATEGORIES',
        routerLink: '/catogories',

        template: () =>
          this._sanitizer
            .bypassSecurityTrustHtml(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3335 3.33366H15.0002C15.4422 3.33366 15.8661 3.50925 16.1787 3.82181C16.4912 4.13437 16.6668 4.5583 16.6668 5.00033V16.667C16.6668 17.109 16.4912 17.5329 16.1787 17.8455C15.8661 18.1581 15.4422 18.3337 15.0002 18.3337H5.00016C4.55814 18.3337 4.13421 18.1581 3.82165 17.8455C3.50909 17.5329 3.3335 17.109 3.3335 16.667V5.00033C3.3335 4.5583 3.50909 4.13437 3.82165 3.82181C4.13421 3.50925 4.55814 3.33366 5.00016 3.33366H6.66683M10.0002 9.16699H13.3335M10.0002 13.3337H13.3335M6.66683 9.16699H6.67516M6.66683 13.3337H6.67516M7.50016 1.66699H12.5002C12.9604 1.66699 13.3335 2.04009 13.3335 2.50033V4.16699C13.3335 4.62723 12.9604 5.00033 12.5002 5.00033H7.50016C7.03993 5.00033 6.66683 4.62723 6.66683 4.16699V2.50033C6.66683 2.04009 7.03993 1.66699 7.50016 1.66699Z" stroke="currentColor" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
</svg>



        `),
      },
      {
        label: 'OCCASIONS',
        routerLink: '/occasions',

        template: () =>
          this._sanitizer.bypassSecurityTrustHtml(`
<svg width="20" height="20" class="menu-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.83317 9.41699L1.6665 18.3337L10.5832 15.1753M3.33317 2.50033H3.3415M18.3332 6.66699H18.3415M12.4998 1.66699H12.5082M18.3332 16.667H18.3415M18.3332 1.66699L16.4665 2.29199C15.9352 2.46898 15.4818 2.82503 15.1839 3.29926C14.8859 3.7735 14.762 4.33649 14.8332 4.89199C14.9165 5.60866 14.3582 6.25033 13.6248 6.25033H13.3082C12.5915 6.25033 11.9748 6.75033 11.8415 7.45033L11.6665 8.33366M18.3332 10.8337L17.6498 10.5587C16.9332 10.2753 16.1332 10.7253 15.9998 11.4837C15.9082 12.067 15.3998 12.5003 14.8082 12.5003H14.1665M9.1665 1.66699L9.4415 2.35033C9.72484 3.06699 9.27484 3.86699 8.5165 4.00033C7.93317 4.08366 7.49984 4.60033 7.49984 5.19199V5.83366M9.1665 10.8337C10.7748 12.442 11.5248 14.3087 10.8332 15.0003C10.1415 15.692 8.27484 14.942 6.6665 13.3337C5.05817 11.7253 4.30817 9.85866 4.99984 9.16699C5.6915 8.47533 7.55817 9.22533 9.1665 10.8337Z" stroke="currentColor" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


        `),
      },
      {
        label: 'CONTACT',
        routerLink: '/contact',

        template: () =>
          this._sanitizer.bypassSecurityTrustHtml(`
<svg width="20" height="20" class="menu-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.5 9.16699H5C5.44203 9.16699 5.86595 9.34259 6.17851 9.65515C6.49107 9.96771 6.66667 10.3916 6.66667 10.8337V13.3337C6.66667 13.7757 6.49107 14.1996 6.17851 14.5122C5.86595 14.8247 5.44203 15.0003 5 15.0003H4.16667C3.72464 15.0003 3.30072 14.8247 2.98816 14.5122C2.67559 14.1996 2.5 13.7757 2.5 13.3337V9.16699ZM2.5 9.16699C2.5 8.18208 2.69399 7.20681 3.0709 6.29687C3.44781 5.38692 4.00026 4.56013 4.6967 3.86369C5.39314 3.16725 6.21993 2.61481 7.12987 2.2379C8.03982 1.86099 9.01509 1.66699 10 1.66699C10.9849 1.66699 11.9602 1.86099 12.8701 2.2379C13.7801 2.61481 14.6069 3.16725 15.3033 3.86369C15.9997 4.56013 16.5522 5.38692 16.9291 6.29687C17.306 7.20681 17.5 8.18208 17.5 9.16699M17.5 9.16699V13.3337M17.5 9.16699H15C14.558 9.16699 14.134 9.34259 13.8215 9.65515C13.5089 9.96771 13.3333 10.3916 13.3333 10.8337V13.3337C13.3333 13.7757 13.5089 14.1996 13.8215 14.5122C14.134 14.8247 14.558 15.0003 15 15.0003H15.8333C16.2754 15.0003 16.6993 14.8247 17.0118 14.5122C17.3244 14.1996 17.5 13.7757 17.5 13.3337M17.5 13.3337V15.0003C17.5 15.8844 17.1488 16.7322 16.5237 17.3573C15.8986 17.9825 15.0507 18.3337 14.1667 18.3337H10" stroke="currentColor" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


        `),
      },
      {
        label: 'ABOUT',
        routerLink: '/about',

        template: () =>
          this._sanitizer.bypassSecurityTrustHtml(`
        <svg width="20" height="20" class="menu-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99984 13.3337V10.0003M9.99984 6.66699H10.0082M18.3332 10.0003C18.3332 14.6027 14.6022 18.3337 9.99984 18.3337C5.39746 18.3337 1.6665 14.6027 1.6665 10.0003C1.6665 5.39795 5.39746 1.66699 9.99984 1.66699C14.6022 1.66699 18.3332 5.39795 18.3332 10.0003Z" stroke="currentColor" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

        `),
      },
    ];
  }
  // onMenuItemClick(item: any, event: Event) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   if (item.command) {
  //     item.command(event);
  //   }
  //   if (item.command) {
  //     item.command({ originalEvent: event });

  //   } else if (item.routerLink) {
  //     this._router.navigate([item.routerLink]);
  //   }
  // }

  // darkmode
  private loadFirstName(): void {
    this.firstName = this._StorageService.getItem('firstName');
    this.photo = this._StorageService.getItem('photo');
    this.buildMenus();
  }
  //

  private onUserUpdated = () => {
    this.loadFirstName();
  };

  ngOnDestroy() {
    try {
      window.removeEventListener('user-updated', this.onUserUpdated);
    } catch (e) {}
  }

  private async loadUserLocation(): Promise<void> {
    try {
      const { latitude, longitude } = await this.getUserLocation();

      this._locationService.getCityFromCoords(latitude, longitude).subscribe({
        next: (city) => {
          this.city = city;
          console.log('City:', city);
        },
        error: (err) => {
          this.city = 'Unknown City';
          console.error('Error fetching city:', err);
        },
      });
    } catch (err) {
      this.city = 'Unknown City';
      console.error('Error getting user location:', err);
    }
  }

  private getUserLocation(): Promise<{ latitude: number; longitude: number }> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) =>
            resolve({
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
            }),
          (err) => reject(err)
        );
      } else {
        reject('Geolocation not supported');
      }
    });
  }

  toggleTheme() {
    this.store.dispatch(toggleTheme());
  }
  showDialog() {
    this.visiblee = true;
  }

  hideDialog() {
    this.visiblee = false;
  }

  onMenuItemClick(item: any, event: any) {
    if (item.command) {
      item.command(event);
    }
  }
}
